document.addEventListener("DOMContentLoaded", function () {
  // Add a click event listener to the close button
  closePopup.addEventListener("click", function () {
    // Pause the video and hide the popup
    popupVideo.pause();
    videoPopup.style.display = "none";
  });
});
function playVid(videoId) {
  let str = videoId;
  str = str.substring(1);
  var video = $("#" + str);
  // Detect play/pause state of video and toggle
  if (video.get(0).paused) {
    video.get(0).play();
  } else {
    video.get(0).pause();
  }
  $("#" + videoId)
    .find("svg")
    .toggle("hideDiv");
  const videoLink = this.getAttribute("data-video");
  alert(videoLink);
  // Set the video source and show the popup
  popupVideo.src = videoLink;
  videoPopup.style.display = "block";
}
$(".vidoe_slider").slick({
  slidesToShow: 4.3,
  slidesToScroll: 1,
  dots: false,
  arrow: true,
  swipe: true,
  prevArrow:
    '<button type="button" class="slick-prev"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_76_138)"><path d="M1.6001 8L9.6001 16L10.4001 15.2L3.2001 8L10.4001 0.8L9.6001 0L1.6001 8Z" fill="#111827" stroke="#111827" stroke-width="0.16"/></g><defs><clipPath id="clip0_76_138"><rect width="16" height="16" fill="white"/></clipPath></defs></svg></button>',
  nextArrow:
    '<button type="button" class="slick-next"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_76_142)"><path d="M14.4 8L6.40002 16L5.60002 15.2L12.8 8L5.60002 0.8L6.40002 0L14.4 8Z" fill="#111827" stroke="#111827" stroke-width="0.16"/></g><defs><clipPath id="clip0_76_142"><rect width="16" height="16" fill="white" transform="matrix(-1 0 0 1 16 0)"/></clipPath></defs></svg></button>',
  cssEase: "linear",
  infinite: false, // Remove infinite loop
  responsive: [
    { breakpoint: 1200, settings: { slidesToShow: 3 } },
    { breakpoint: 1023, settings: { slidesToShow: 2 } },
    // {
    //   breakpoint: 767,
    //   settings: { slidesToShow: 1, centerMode: false, centerPadding: "60px" },
    // },
    {
      breakpoint: 767,
      settings: "unslick",
    },
  ],
});
